import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SessionService } from './system/session.service';
import { AuthService } from './system/auth.service';
import { FundService } from './system/fund.service';
import { ChartAccountService } from './system/chartaccount.service';
import { AccountService } from './system/account.service';
import { AllotmentService } from './system/allotment.service';
import { ObligationService } from './system/obligation.service';
import { PayeeService } from './system/payee.service';
import { FunctionService } from './system/function.service';
import { HrService } from './system/hr.service';
import { MfoPapService } from './system/mfopap.service';
import { RealignmentService } from './system/realignment.service';
import { ReportsService } from './system/reports.service';
import { RegisterService } from './system/register.service';
import { DashboardService } from './system/dashboard.service';
import { ManageBudgetAccountService } from './system/manage-budget-account.service';
import { CaaService } from './system/caa.service';

const SERVICES = [
  SessionService,
  AuthService,
  FundService,
  ChartAccountService,
  AccountService,
  AllotmentService,
  ObligationService,
  PayeeService,
  FundService,
  FunctionService,
  HrService,
  MfoPapService,
  RealignmentService,
  ReportsService,
  RegisterService,
  DashboardService,
  ManageBudgetAccountService,
  CaaService
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class MockDataModule {
  static forRoot(): ModuleWithProviders<MockDataModule> {
    return {
      ngModule: MockDataModule,
      providers: [
        ...SERVICES,
      ],
    };
  }
}
